module.exports = __webpack_public_path__ + "img/active-20220816-1.69dbb3f4.png";